// src/chatbot/Stories.js
import React from 'react';
import ChatbotCore from './ChatbotCore';

// 🟨 CHANGED: Expanded, branch-neutral interview context with full guidance
const interviewContext = `
This chatbot is to interview my dad about his life stories with a view to putting them in a book. This interview will cover 1 story.

Your tone is warm, British, and unforced. No corporate speak. No cheesy lines.

INTERVIEW FLOW
1) Ask each main question below in order, one at a time.
2) After each answer, ask 2–3 natural follow-up questions that dig deeper into specifics, examples, and feelings.
3) Keep questions short, conversational, and varied. Do NOT repeat a main question in different words.
4) Balance breadth and depth: help them tell a clear story with vivid detail.
5)Do not ask something as a follow-up question that is already planned for a future question.

FOLLOW-UP STYLE (guidance, not scripts)
- Invite concrete details: people’s roles, places, timings, routines, small objects, sights/sounds/smells, dialogue.
- Prefer: “What happened next?”, “Where were you?”, “Who was there?”, “How did you handle that?”.
- Encourage narrative and reflection without judgement. Keep it humane and steady.
- If memories are recent: allow immediate impressions. If long ago: allow how the memory has changed over time.
- Avoid leading or assumptive prompts. Don’t guess ages, identities, or sensitive attributes.

TRAUMA-AWARE CONDUCT
- If the user hints at difficult or distressing topics, slow down, acknowledge gently, and offer to move on.
- Never push. Offer opt-outs like: “We can skip this if you prefer.”

PACE & LENGTH
- One message = one question (or a small cluster of 2–3 short follow-ups).
- Answers may be long. Encourage depth, but keep your prompts crisp.
- Keep your own messages under ~60–100 words.

HOUSE STYLE
- British spelling.
- No bullet points in questions; keep them as sentences.
- Be curious, not clinical. Keep a human, steady rhythm.

GOAL
Help the interviewee produce rich, book-worthy material about their stories: clear timeline, vivid scenes, and thoughtful reflection, without feeling interrogated.
`;

// 🟨 CHANGED: Month 1 of the one question per month
const questions = [
  
  {
    text: "What do you know, or remember being told, about your family before you were born?",
    followups: 2,
    placeholder: "Either click 'Start Recording' or type into this box."
  },
  {
    text: "What was the place you grew up like, in practical terms?",
    followups: 2,
    placeholder: "Remember, you can submit your answers at any point and re-load the interview at a later date. If you do that, you can just 'Skip' to the questions you want to answer"
  },
  {
    text: "Who were the main people in your family while you were growing up?",
    followups: 2,
    placeholder: "Remember, you can submit your answers at any point and re-load the interview at a later date. If you do that, you can just 'Skip' to the questions you want to answer"
  },
  {
    text: "Were there any family stories or anecdotes that were often repeated?",
    followups: 2,
    placeholder: "Remember, you can submit your answers at any point and re-load the interview at a later date. If you do that, you can just 'Skip' to the questions you want to answer"
  },
  {
    text: "What kinds of rules, routines, or expectations were common in your family?",
    followups: 2,
    placeholder: "Remember, you can submit your answers at any point and re-load the interview at a later date. If you do that, you can just 'Skip' to the questions you want to answer"
  },
   {
    text: "Were there any events or periods that changed the family’s circumstances?",
    followups: 2,
    placeholder: "Remember, you can submit your answers at any point and re-load the interview at a later date. If you do that, you can just 'Skip' to the questions you want to answer"
  },
     
  {
    text: "That concludes today's questions, is there anything else you would like to add?",
    followups: 0,
    placeholder: "This could be anything at all. Or if you want to include notes for the editor, please do"
  }
];

export default function Stories() {
  return (
    <ChatbotCore
      title="Family Stories"
      baseQuestions={questions}
      interviewContext={interviewContext}
    />
  );
}

